<template lang='pug'>
md-field(style='margin-top: 0;')
  md-textarea(
    v-model='url'
    disabled
    md-autogrow
    style='background-color: rgb(244, 244, 244); border-color: rgb(244, 244, 244); opacity: 0.8')
</template>

<script>
export default {
  props: {
    protocol: {
      type: String,
      default: ''
    },
    host: {
      type: String,
      default: ''
    },
    path: {
      type: String,
      default: ''
    },
    hostParameters: {
      type: Object,
      default: Object
    },
    pathParameters: {
      type: Object,
      default: Object
    },
    queryParameters: {
      type: Object,
      default: Object
    }
  },
  data () {
    return {
      url: '',
      computedHost: '',
      computedPath: '',
      computedQuery: ''
    }
  },
  watch: {
    protocol: {
      handler: 'updateUrl',
      immediate: true
    },
    host: {
      handler: 'mountHost',
      immediate: true
    },
    hostParameters: {
      handler: 'mountHost',
      deep: true,
      immediate: true
    },
    path: {
      handler: 'mountPath',
      immediate: true
    },
    pathParameters: {
      handler: 'mountPath',
      deep: true,
      immediate: true
    },
    queryParameters: {
      handler: 'mountQuery',
      deep: true,
      immediate: true
    }
  },
  methods: {
    replaceProps (string, propsObj) {
      let result = string
      for (const key in propsObj) {
        const regex = `%\\{${key}\\}`
        const re = new RegExp(regex, 'g')
        result = result.replace(re, propsObj[key])
      }
      return result
    },
    mountHost () {
      this.computedHost = this.replaceProps(this.host, this.hostParameters)
      this.updateUrl()
    },
    mountPath () {
      this.computedPath = this.replaceProps(this.path, this.pathParameters)
      this.updateUrl()
    },
    mountQuery () {
      const params = Object.entries(this.queryParameters)
        .map(([key, value]) => `${key}=${value}`)
        .join('&')
      if (params) {
        this.computedQuery = '?' + params
      } else {
        this.computedQuery = params
      }
      this.updateUrl()
    },
    updateUrl () {
      this.url = `${this.protocol}${this.computedHost}${this.computedPath}${this.computedQuery}`
    }
  }
}
</script>
